import { createContext } from 'react';

export const ThemeContext = createContext(/** @type {any} */ (null));
